import React, {
  Fragment,
  useRef,
  useCallback,
  useEffect,
  useState,
} from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import AuthLayout from "../Layout/AuthLayout";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../Store/index";
import {
  useAddJobFairMutation,
  useUploadImageMutation,
  useUserProfileQuery,
} from "../Store/api/AuthApi";
import Swal from "sweetalert2";
import { useGetFavoriteCompanyQuery } from "../Store/api/DataApi";
import CompanyComponent from "../Components/Resume/CompanyComponent";
import { useUnFavoriteCompanyMutation } from "../Store/api/DataApi";
import { error, success } from "../Services/CommonService";
import moment from "moment";

export default function Resume() {
  const modalRef = useRef();
  const bootstrap = window.bootstrap;
  let model = null;
  const profile = useSelector((state: RootState) => state.auth?.profile);
  const { is_job_fair_live, job_fair_banner, job_fair_id } = useSelector(
    (state: RootState) => state.auth
  );

  const navigate = useNavigate();
  const [path, setPath] = useState("");
  const [companies, setCompanies] = useState([]);

  const profileApi = useUserProfileQuery();
  const [uploadFile] = useUploadImageMutation();
  const companyApi = useGetFavoriteCompanyQuery();
  const [unFavoriteCompany] = useUnFavoriteCompanyMutation();
  const [addJobFair] = useAddJobFairMutation();

  useEffect(() => {
    if (profileApi?.error) {
      Swal.fire("Error", profileApi?.error.data?.message, "error");
    }
  }, [profileApi?.error]);

  useEffect(() => {
    if (
      profileApi.data?.error !== undefined &&
      profileApi.data?.error === "Invalid token!"
    ) {
      navigate("/logout");
    }

    if (
      companyApi.data?.error !== undefined &&
      companyApi.data?.error === "Invalid token!"
    ) {
      navigate("/logout");
    }
  }, [profileApi, companyApi, navigate]);

  useEffect(() => {
    if (companyApi?.data?.path !== undefined) {
      setPath(companyApi?.data?.path);
      setCompanies(companyApi?.data?.data);
    }
  }, [companyApi?.data, setPath, setCompanies]);

  const handleUnfollow = useCallback(
    (id) => {
      unFavoriteCompany(id)
        .then((res) => {
          if (res.error) {
            error(res?.error?.data?.error);
          } else {
            companyApi?.refetch();
            success(res?.data?.message);
          }
        })
        .catch((err) => {
          error(err?.error?.data?.error);
        });
    },
    [unFavoriteCompany, companyApi]
  );

  const handleUploadImage = useCallback(
    (file) => {
      var filePath = file.name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      if (!allowedExtensions.exec(filePath)) {
        error("Please upload file having extensions .jpeg/.jpg/.png only.");
        return false;
      }
      uploadFile(file)
        .then((res) => {
          if (res.data?.message) {
            profileApi.refetch();
            success(res.data?.message);
          } else {
            error(res?.error?.data?.error);
          }
        })
        .catch((err) => console.log(err));
    },
    [uploadFile, profileApi]
  );

  const onOpenModal = useCallback(() => {
    const modalEle = modalRef.current;
    if (is_job_fair_live && window.$.cookie("jobfair") == undefined) {
      model = new bootstrap.Modal(modalEle, {
        backdrop: "static",
        keyboard: false,
      });
      model.show();
    }
  }, [model, is_job_fair_live]);

  const onCloseModal = useCallback(() => {
    model.hide();
    window.$(".modal-backdrop").remove();
    window.$.cookie("jobfair", "1", { expires: 2 / 24 });
    model = null;
  }, [model]);

  const onAddJobFair = useCallback(() => {
    addJobFair({ candidate_id: profile?.id, fair_event_id: job_fair_id })
      .then((res) => {
        if (res.error !== undefined) {
          error(res?.error?.data?.error);
        } else {
          success(res?.data?.success);
          profileApi.refetch();
          if (model) onCloseModal();
        }
      })
      .catch((err) => {
        error(err?.error?.data?.error);
      });
  }, [addJobFair, profile, onCloseModal, model, job_fair_id]);

  useEffect(() => {
    profileApi?.refetch();
    companyApi?.refetch();
    onOpenModal();
  }, []);

  return (
    <Fragment>
      <PageBannerComponent title="My Dashboard" />
      <AuthLayout>
        {profile?.lgbt_status === 0 && (
          <div className="alert alert-primary" role="alert">
            Your profile is under review. We will get in touch with you soon to
            verify your account.
          </div>
        )}
        {is_job_fair_live && (
          <div className="d-flex flex-row justify-content-between bg-warning mb-2 p-2">
            <div className="text-light">
              Apply for RISE 2025 Job Fair Pass for the 10th of May, Saturday
            </div>
            <button
              type="button"
              onClick={onAddJobFair}
              className="btn btn-success btn-sm"
            >
              Interested
            </button>
          </div>

          //  <div className="alert alert-primary" role="alert">
          //    Your profile is under review. We Will get in touch with you soon to
          //    verify your account.
          //  </div>
        )}
        <div className="inner-box my-resume">
          <div className="author-resume d-inline">
            <div className="thumb text-center">
              <div className="mb-2">
                {profile?.profile_picture ? (
                  <img src={profile?.profile_picture} alt="" width={120} />
                ) : (
                  <div className="text-center">
                    <i className="fa fa-user fa-5x"></i>
                  </div>
                )}
              </div>

              <label htmlFor="imgupload">
                <input
                  type="file"
                  id="imgupload"
                  onChange={(e) => handleUploadImage(e.target.files[0])}
                  style={{ display: "none" }}
                />
                <span className="btn btn-sm btn-warning text-white">
                  <i className="fa fa-upload"></i> Image
                </span>
              </label>
            </div>

            <Link
              target="_blank"
              to={profile?.resume_file}
              className="btn btn-sm btn-success float-right"
            >
              <i className="fa fa-download" /> Resume
            </Link>
            <div className="author-info">
              <h3>
                {profile?.legal_name}
                <Link to="/edit-profile">
                  <i className="fa fa-pencil-square-o ml-1" />
                </Link>
              </h3>
              <p className="sub-title mt-10">
                {profile?.current_profile_role}
                <br />
                <span className="address">
                  <i className="fa fa-briefcase" />{" "}
                  {profile?.current_previous_company}
                </span>
                &nbsp; &nbsp;
                <span>
                  <i className="fa fa-location-arrow" /> {profile?.city_name}
                </span>
                <br />
                <span>
                  <i className="fa fa-phone" />
                  {profile?.ph_country_code + " " + profile?.phone_number}
                </span>
                &nbsp; &nbsp;
                <span>
                  <i className="fa fa-inbox" /> {profile?.email}
                </span>
                <br />
                <span title="Last Profile Update Time">
                  <i className="fa fa-pencil" />
                  {" " +
                    moment(profile?.updated_at).format("MMM Do YYYY, h:mm a")}
                </span>
                &nbsp; &nbsp;
                <span title="Last Login Time">
                  <i className="fa fa-history" />
                  {" " +
                    moment(profile?.last_login).format("MMM Do YYYY, h:mm a")}
                </span>
                {/* <span className="address">
                  <i className="fa fa-linkedin" /> This will appear if user
                  fills this field
                </span> */}
              </p>
            </div>
          </div>
          <div className="about-me item">
            <h3>About Me</h3>
            <p>{profile?.about_yourself}</p>
          </div>
          <div className="work-experence item">
            <h3>Work Experience</h3>
            <h4>{profile?.current_profile_role}</h4>
            <h5>{profile?.current_previous_company}</h5>
            <span className="date">
              {profile?.total_experience_years +
                " Years " +
                profile?.total_experience_months +
                " Months"}
            </span>
            {/* <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero
              vero, dolores, officia quibusdam architecto sapiente eos voluptas
              odit ab veniam porro quae possimus itaque, quas! Tempora sequi
              nobis, atque incidunt!
            </p>
            <p>
              <Link to="#">4 Projects</Link>
            </p>
            <br />
            <h4>UI Designer</h4>
            <h5>Whale Creative</h5>
            <span className="date">Fab 2017-Present(2year)</span>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero
              vero, dolores, officia quibusdam architecto sapiente eos voluptas
              odit ab veniam porro quae possimus itaque, quas! Tempora sequi
              nobis, atque incidunt!
            </p>
            <p>
              <Link to="#">4 Projects</Link>
            </p> */}
          </div>
          <div className="education item">
            <h3>Education</h3>
            <h4>{profile?.institution_name}</h4>
            <p>{profile?.highest_education}</p>
            <span className="date">{profile?.education_passing_year_name}</span>
            {/* <br />
            <h4>Massachusetts Institute Of Technology</h4>
            <p>Bachelor of Computer Science</p>
            <span className="date">2010-2014</span> */}
          </div>
          <div className="education item">
            <h3>Following Company</h3>
            <div className="row">
              {companies.length > 0 &&
                companies.map((com, i) => (
                  <CompanyComponent
                    item={com}
                    path={path}
                    handleUnfollow={handleUnfollow}
                    key={i}
                  />
                ))}
              {/* <div className="col-sm-3">
                <div className="text-center">
                  <div className="product-image3 ath_hover">
                    <img
                      src={require("../Assets/img/comapny-logos/acuity-1.jpg")}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <Link to="" className="">
                    00748 followers
                  </Link>{" "}
                  |
                  <Link to="" className="">
                    unfollow
                  </Link>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="text-center">
                  <div className="product-image3 ath_hover">
                    <img
                      src={require("../Assets/img/comapny-logos/acuity-1.jpg")}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <Link to="" className="">
                    00748 followers
                  </Link>{" "}
                  |
                  <Link to="" className="">
                    unfollow
                  </Link>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="text-center">
                  <div className="product-image3 ath_hover">
                    <img
                      src={require("../Assets/img/comapny-logos/acuity-1.jpg")}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <Link to="" className="">
                    00748 followers
                  </Link>{" "}
                  |
                  <Link to="" className="">
                    unfollow
                  </Link>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          ref={modalRef}
          id="staticBackdrop"
          data-bs-backdrop="static"
          backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content p-0">
              {/* <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  New message
                </h5>
                <button
                  type="button"
                  className="btn-close bg-transparent border-0"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={onCloseModal}
                >
                  X
                </button>
              </div> */}
              <div className="modal-body">
                {job_fair_banner && (
                  <img src={job_fair_banner} className="img-fluid" />
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={onCloseModal}
                >
                  Skip
                </button>
                <button
                  type="button"
                  onClick={onAddJobFair}
                  className="btn btn-primary"
                >
                  Interested
                </button>
              </div>
            </div>
          </div>
        </div>
      </AuthLayout>
    </Fragment>
  );
}
